export default __webpack_public_path__ + "static/media/fusion-012.237d48ac.svg";